"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameDrPicasoInitializer = exports.frameHybridInitializer = exports.frameInitializer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const translations_initializer_1 = require("../../translations/translations.initializer");
const libraries_initializer_1 = require("../../libraries/libraries.initializer");
const featureFlag_initializer_1 = require("../../featureFlag/featureFlag.initializer");
const session_initializer_1 = require("../../security/session/session.initializer");
const authoriser_initializer_1 = require("../../security/authoriser/authoriser.initializer");
const xhr_initalizer_1 = require("../../xhr/xhr.initalizer");
const authenticator_initializers_1 = require("../../security/authenticator/authenticator.initializers");
const locale_initializers_1 = require("../../locale/locale.initializers");
const tracker_initializer_1 = require("../../tracker/tracker.initializer");
const mobileConnector_initializer_1 = require("../../mobileConnector/mobileConnector.initializer");
const eventBus_initializer_1 = require("../../eventBus/eventBusManager/eventBus.initializer");
const commonsInitializers = config => {
    return {
        authoriser: new authoriser_initializer_1.AuthoriserInitializer(),
        libraries: new libraries_initializer_1.LibrariesInitializer(config.libraries()),
        locale: new locale_initializers_1.LocaleInitializer(config.language),
        eventBus: new eventBus_initializer_1.EventBusInitializer(),
    };
};
const frameInitializer = async (config) => {
    const { authoriser, locale, libraries, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionInitializer(config, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorInitializer(config, session, authoriser);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        libraries,
        featureFlags,
        tracker,
        translations,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.frameInitializer = frameInitializer;
const frameHybridInitializer = async (config) => {
    const { authoriser, locale, libraries, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionInitializer(config, eventBus);
    const mobileConnector = new mobileConnector_initializer_1.MobileConnectorInitializer();
    const sessionHybrid = new session_initializer_1.SessionHybridInitializer(mobileConnector, eventBus);
    const API = new xhr_initalizer_1.XhrHybridInitializer(config, session, authoriser, locale, mobileConnector);
    const authenticator = new authenticator_initializers_1.AuthenticatorHybridInitializer(sessionHybrid, mobileConnector);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        libraries,
        featureFlags,
        tracker,
        translations,
        sessionHybrid,
        authenticator,
        mobileComunicator: mobileConnector,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.sessionHybrid.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.frameHybridInitializer = frameHybridInitializer;
const frameDrPicasoInitializer = async (config) => {
    const { authoriser, locale, libraries, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionDRPicasoInitializer(config, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorDRPicasoInitializer(config, session);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        libraries,
        featureFlags,
        tracker,
        translations,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.frameDrPicasoInitializer = frameDrPicasoInitializer;
//# sourceMappingURL=frame.initializers.js.map